import microuniversoApi from "app/api/microuniversoApi";
import { Breadcrumb2Container } from "app/components/breadcrumb2/Breadcrumb2Container";
import { NotaFiscalDevolucao } from "app/types/pesquisa-orcamento/consultas/Devolucoes";
import { ItensDevolucao } from "app/types/pesquisa-orcamento/consultas/sub-consultas-devolucoes/Itens";
import { tratamentoErroPadrao } from "app/use-cases";
import { Dict } from "app/utils/Dict";
import globalMU from "globalMU";
import React, { useEffect, useRef, useState } from "react";
import { DevolucoesItens } from "./DevolucoesItens";
import { DadosDaPesquisaOrcamento } from "app/types/pesquisa-orcamento/PesquisaOrcamento";
import { useMenuSubConsultasDevolucoes } from "app/components/pesquisa-orcamento/menu-sub-consultas-devolucoes/useMenuSubConsultasDevolucoes";
import { useMenuConsultasPesquisaOrcamento } from "app/components/pesquisa-orcamento/menu-consultas-pesquisa-orcamento/useMenuConsultasPesquisaOrcamento";

export type DevolucoesItensContainerProps = {
    devolucaoSelecionada: Partial<NotaFiscalDevolucao>;
    orcamentoSelecionado: Partial<DadosDaPesquisaOrcamento>
    passos: Dict<string, () => void>,
    onRemover?: () => void,
    onVoltar: () => void,
};

export const DevolucoesItensContainer = (props: DevolucoesItensContainerProps) => {

    const [dados, setDados] = useState<ItensDevolucao[]>();
    const [itemSelecionado, setItemSelecionado] = useState<ItensDevolucao>();
    const [mostrarDetalhesItensDevolucao, setMostrarItensDevolucoes] = useState(false);

    const passosInterno = useRef<Dict<string, () => void>>(new Dict(Object.assign({}, props.passos.map)))

    const onObterDadosItens = async () => {
        try {
            globalMU.blockUI();
            const resultado = await microuniversoApi.NotaFiscalEntrada.Itens(
                Number(props.devolucaoSelecionada.Codigo)
            );

            if (("Error" in resultado)) {
                onVoltar();
                return
            }

            setDados(resultado);
        }
        catch (e) {
            tratamentoErroPadrao(e);
        }
        finally {
            globalMU.unblockUI();
        }
    }

    const onMostrarDetalhesItensDevolucao = (mostrar: boolean, item: ItensDevolucao) => {
        setMostrarItensDevolucoes(mostrar)
        setItemSelecionado(item)
    }

    const onPassoSelecionado = (passo: string) => {
        props.onRemover()
        passosInterno.current.get(passo)()
    }

    const onVoltar = () => {
        props.onRemover()
        props.onVoltar()
    }

    useMenuSubConsultasDevolucoes({
        devolucaoSelecionada: props.devolucaoSelecionada,
        orcamentoSelecionado: props.orcamentoSelecionado,
        onVoltar: () => props.onVoltar(),
        passos: props.passos
    })

    useMenuConsultasPesquisaOrcamento({
        onVoltar:  props.onVoltar,
        orcamentoSelecionado: props.orcamentoSelecionado,
        passos: new Dict(Object.assign({}, props.passos.remove("Devoluções").map)),
    })

    useEffect(() => {
        passosInterno.current.set("Devoluções", () => props.onVoltar())
        passosInterno.current.set("Itens", () => { })
        onObterDadosItens();
    }, [])


    return <>

        <Breadcrumb2Container
            passos={passosInterno.current.keysToList()}
            exibirBotaoLimpar={false}
            exibirBotaoVoltar={true}
            id="DevolucoesItensContainer"
            onPassoSelecionado={onPassoSelecionado}
            onBotaoVoltarClicado={() => onVoltar()}
        />

        <DevolucoesItens
            mostrarDetalhesItensDevolucao={mostrarDetalhesItensDevolucao}
            onMostrarDetalhesItensDevolucao={onMostrarDetalhesItensDevolucao}
            itensDevolucoes={dados}
            itemSelecionado={itemSelecionado}
        />
    </>
}
